export const GetUserToken = (thunkAPI) => {
	return thunkAPI.getState().auth.mainUser.token;
};
